import React from 'react';
import { Button, Form } from 'antd';
//mobx
import { useStore } from '@/store';
import { observer } from 'mobx-react-lite';
import { set, runInAction } from 'mobx';

import 'moment/locale/zh-cn';

const App = () => {
    //mobx
    const { ShedsStore } = useStore()
    // 取消按钮
    const [form] = Form.useForm();



    //表单提交
    const onFinish = () => {
        ShedsStore.getSubmit({ sdcode: '' })
        runInAction(() => {
            set(ShedsStore, { isAshow: false })
        })
    };

    //表单取消
    const onReset = () => {
        form.resetFields();
        runInAction(() => {
            set(ShedsStore, { isAshow: false })
        })
    };


    return (
        <>
            <Form
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 14,
                }}
                form={form}
                onFinish={onFinish}
            >
                <div style={{ margin: '10px', fontSize: '20px' }}> 确定解绑设备?</div>
                <Form.Item wrapperCol={{ offset: 6 }}>
                    <Button type="primary" htmlType="submit">
                        确定
                    </Button>
                    <Button htmlType="button" onClick={onReset} style={{ marginLeft: '15px' }}>
                        取消
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}
export default observer(App)